import { createListModalContainer } from 'factories/ListModal'
import actions from 'actions/entityLists'
import Component from 'components/Lists/Associations'

export default createListModalContainer({ actions })(Component)
